import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Menu } from './menu.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MenuItemComponent } from './menu-item/menu-item.component';

@NgModule({
	declarations: [
		Menu,
		MenuItemComponent
	],
	imports: [
		CommonModule,
		MatMenuModule,
		MatIconModule,
		MatButtonModule
	],
	providers: [],
	exports: [
		Menu
	]
})
export class MenuModule { }
